/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetPatientExerciseSchema } from '../models/GetPatientExerciseSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AllPatientExercisesApi {
    /**
     * Api Get Detail
     * Get patient exercises.
     * @returns GetPatientExerciseSchema OK
     * @throws ApiError
     */
    public static patientExercisesApiGetDetailGet({
        patientExerciseId,
        latest = false,
    }: {
        patientExerciseId: string,
        latest?: boolean,
    }): CancelablePromise<GetPatientExerciseSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/patient-exercises/all/{patient_exercise_id}/',
            path: {
                'patient_exercise_id': patientExerciseId,
            },
            query: {
                'latest': latest,
            },
        });
    }
    /**
     * Api Get
     * Get patient exercises.
     * @returns GetPatientExerciseSchema OK
     * @throws ApiError
     */
    public static patientExercisesApiGetGet({
        patientId,
        includeAutomaticallyGenerated = false,
        startAt,
    }: {
        patientId?: (string | null),
        includeAutomaticallyGenerated?: boolean,
        startAt?: (string | null),
    }): CancelablePromise<Array<GetPatientExerciseSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/patient-exercises/all/',
            query: {
                'patient_id': patientId,
                'include_automatically_generated': includeAutomaticallyGenerated,
                'start_at': startAt,
            },
        });
    }
}
